import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProcessSection() {
  return <section className="py-28 px-6 bg-gray-50" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-235">
            Arrendar deja de ser un proceso desordenado
          </h2>
          <p className="text-lg text-gray-600" data-id="element-236">
            Para quien arrienda y para quien busca, todo cambia.
          </p>
        </motion.div>

        {/* Two Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-20" data-id="element-237">
          {/* Left Card — Corredores */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 md:p-10" data-id="element-238">
            <h3 className="text-xl font-extrabold text-gray-900 mb-2" data-id="element-239">
              Corredores y propietarios
            </h3>
            <p className="text-sm font-bold text-gray-500 mb-8" data-id="element-240">
              Menos tiempo revisando, más tiempo cerrando.
            </p>
            <ul className="space-y-5" data-id="element-241">
              {['Recibes solo postulantes que sí califican', 'Evitas revisar solicitudes una por una', 'Reduces horas de evaluación manual', 'Tomas decisiones más rápido'].map(text => <li key={text} className="flex items-start gap-3" data-id="element-242">
                  <CheckCircle2 className="text-brand-600 shrink-0 mt-0.5" size={22} data-id="element-243" />
                  <span className="text-base text-gray-700 font-medium" data-id="element-244">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Card — Arrendatarios (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-50/60 rounded-2xl border border-brand-100 shadow-md p-8 md:p-10" data-id="element-245">
            <h3 className="text-xl font-extrabold text-gray-900 mb-2" data-id="element-246">
              Para quien busca arriendo
            </h3>
            <p className="text-sm font-bold text-brand-700 mb-8" data-id="element-247">
              Dejas de postular a ciegas.
            </p>
            <ul className="space-y-5" data-id="element-248">
              {['Sabes si tienes opciones antes de postular', 'Entiendes exactamente qué te van a pedir', 'Ves solo arriendos donde podrías quedar', 'Dejas de perder tiempo en postulaciones inútiles'].map(text => <li key={text} className="flex items-start gap-3" data-id="element-249">
                  <CheckCircle2 className="text-brand-600 shrink-0 mt-0.5" size={22} data-id="element-250" />
                  <span className="text-base text-gray-900 font-medium" data-id="element-251">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Bottom Line */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-center" data-id="element-252">
          <p className="text-xl md:text-2xl font-bold text-gray-900 tracking-tight" data-id="element-253">
            Todos hablan el mismo idioma.
          </p>
        </motion.div>
      </div>
    </section>;
}